var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{ref:"tabs",attrs:{"tab-position":_vm.tabPosition,"before-leave":_vm.beforeLeave,"type":_vm.type},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }